import { api, fetcher } from "services/api.service";
import { LocationManagementLocation } from "types/locationManagement/location";
import { withActionErrorAlert } from "utils/withActionError";
import { withAuth } from "routes/utils/withAuth";
import { useGlobalAlert } from "hooks/useAlert";

export const loader = withAuth(async ({ params }: { params: Record<string, string | undefined> }) => {
  const location = await fetcher<LocationManagementLocation>(`/location_management/locations/${params.locationId}`);
  return { location };
});

export async function action({ request, params }: { request: Request; params: Record<string, string | undefined> }) {
  const formData = await request.formData();
  const res = await withActionErrorAlert(() =>
    api.request({
      method: "PUT",
      url: `/location_management/locations/${params.locationId}`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    }),
  );
  if (res?.status === 200) {
    useGlobalAlert.alertSuccess("The location was updated successfully.");
    return { updated: true };
  }
  return res;
}
